import { LoginProviderRoutes } from '@/repository/auth';
const { GetAllForUser, RemoveActiveForUser } = LoginProviderRoutes;

export default {
	namespaced: true,
	actions: {
		async index({ commit }) {
			try {
				let res = await GetAllForUser()
				let login_providers = (res.data || [])
				this.commit('auth/user/SET_CURRENT_USER', { login_providers })
				return res;
			}
			catch (error) {
				console.error('Could not get user\'s active login providers.', error);
				throw error;
			}
		},
		async destroy({ commit }, provider) {
			try {
				let res = await RemoveActiveForUser(provider)
				let login_providers = (res.data || [])
				this.commit('auth/user/SET_CURRENT_USER', { login_providers })
				location.reload();
			}
			catch (error) {
				console.error('Could not get remove login provider for user.', error);
				throw error;
			}
		}
	}
}